export default __webpack_public_path__ + "static/media/github.25c78836.png";